import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-about">
            <div className="footer-logo">
              <img src="/mylogo.png" alt="Dr Vaibhav Moghariya Clinic Logo" className="logo-image" />
              <h2>Dr Vaibhav Moghariya Clinic</h2>
            </div>
            <p>Your journey to radiant, healthy skin starts here. We are dedicated to providing the best in dermatological care.</p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/p/Sparsh-SKIN-clinic-Surendranagar-100088513232327/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/sparsh_skin_clinic__?igsh=cG82Z3FrNXRzcmx5" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/#home">Home</a></li>
              <li><a href="/#services">Services</a></li>
              <li><a href="/#about">About Us</a></li>
              <li><a href="/#gallery">Gallery</a></li>
              <li><a href="/#contact">Contact</a></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <p>Dr Vaibhav Moghariya Clinic<br />Behind Axis Bank<br />Bus Station Road<br />Surendranagar, Gujarat 363002</p>
            <p>vaibhavmoghariya1209@gmail.com</p>
            <p>+91 79843 64765</p>
          </div>

          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Subscribe to our newsletter for the latest news and offers.</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Your Email" />
              <button type="submit" className="btn-primary">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Dr Vaibhav Moghariya Clinic. All Rights Reserved.</p>
          <p>Website designed with ❤️ by Jay Moghariya</p>
          <button onClick={scrollToTop} className="back-to-top">↑</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
